<style lang="less">
  @import './login.less';
</style>

<template>
  <div class="login" @keydown.enter="handleSubmit">
    <div class="login-con">
      <Card icon="md-log-in" title="欢迎登录亚洲新能源汽车网管理系统" :bordered="false">
        <div class="form-con">
          <Form ref="loginForm" :model="form" :rules="rules">
            <FormItem prop="username">
              <Input v-model="form.username" placeholder="请输入用户名" size="large" :disabled="loading">
                <span slot="prepend">
                  <Icon :size="26" type="md-contact"></Icon>
                </span>
              </Input>
            </FormItem>
            <FormItem prop="password">
              <Input type="password" v-model="form.password" placeholder="请输入密码" size="large" :disabled="loading">
                <span slot="prepend">
                  <Icon :size="26" type="md-lock"></Icon>
                </span>
              </Input>
            </FormItem>
            <FormItem class="margin-bottom-15">
              <Button type="primary" long :loading="loading" @click="handleSubmit" size="large">登录</Button>
            </FormItem>
          </Form>
        </div>
      </Card>
    </div>
    <Modal v-model="wxQrModel" width="360">
      <p slot="header" style="color:#2d8cf0;">
        <Icon type="information-circled"></Icon>
        <span>请用微信扫码登录</span>
      </p>
      <div style="text-align:center">
        <img :src="wxQrUrl" alt="">
      </div>
      <div slot="footer">
        <Button type="primary" size="large" long @click="wxQrModel = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    ...mapActions([
      'handleLogin'
    ]),
    handleSubmit () {
      let vm = this
      let username = vm.form.username
      let password = vm.form.password
      vm.$refs.loginForm.validate((valid) => {
        if (valid) {
          vm.loading = true
          vm.handleLogin({ username, password }).then(() => {
            vm.$router.push({
              name: 'home'
            })
          }).finally(() => {
            vm.loading = false
          })
        }
      })
    }
  }
}
</script>
<style lang="less">
body {
  background-image: url('../../assets/images/login-bg.jpg');
  background-size: cover;
  background-position: center;
  position: relative;

  .login{
    width: 100%;
    height: 100%;

    &-con{
       position: absolute;
       right: 170px;
       top: 40%;
       transform: translateY(-50%);
       animation:slideIn .3s forwards;
       width: 320px;
      .ivu-card {
        background: rgba(244,247,251, 0.9);
        .ivu-card-head {
          border-bottom: 1px solid #ceced0;
        }
      }
      &-header{
         font-size: 16px;
         font-weight: 300;
         text-align: center;
         padding: 30px 0;
         background: rgba(255,255,255,30);
       }
      .form-con{
        padding: 10px 0 0;
        opacity: 0.8;
      }
      .login-tip{
        font-size: 10px;
        text-align: center;
        color: #c3c3c3;
      }
    }
  }
}
</style>
